export default __webpack_public_path__ + "static/media/leboulou.e17b80a9.png";